import { initialScoState, IScoState } from '../state/sco.state';
import { ScoActions, EScoActions } from '../actions/sco.actions';

export const scoReducers = (state = initialScoState, action: ScoActions): IScoState => {
  switch (action.type) {
    case EScoActions.AddSco: {
      // let array = [];
      //     if (state.sco && state.sco.length > 0) {
      //     array = state.sco.filter(item => item.race !== action.payload.race);
      //     }
      let array = [];
      if (state.sco && state.sco.length > 0) {
        array = state.sco.filter(
          item => item.extra.idCav !== action.payload.extra.idCav || item.cod !== action.payload.cod
        );
      }

      return {
        ...state,
        sco: [...array, action.payload].sort(function(a, b) {
          if (a.quo === b.quo) {
            if (a.extra.idCav > b.extra.idCav) {
              return -1;
            } else {
              return 1;
            }
          }
          return a.quo - b.quo;
        })
      };
    }
    case EScoActions.DelSco: {
      return {
        ...state,
        sco: state.sco.filter(
          item => item.extra.idCav !== action.payload.extra.idCav || item.cod !== action.payload.cod
        )
      };
    }
    case EScoActions.InitSco: {
      return {
        ...state,
        sco: null
      };
    }

    default:
      return state;
  }
};
